// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { dashboardBuilderTemplates16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-dashboard-builder-templates': IconDashboardBuilderTemplates;
    }
}

/**
 * The icon component for the 'dashboardBuilderTemplates' icon
 */
export class IconDashboardBuilderTemplates extends Icon {
    public constructor() {
        super(dashboardBuilderTemplates16X16);
    }
}

registerIcon('icon-dashboard-builder-templates', IconDashboardBuilderTemplates);
export const iconDashboardBuilderTemplatesTag = 'nimble-icon-dashboard-builder-templates';
